import { JSX } from 'react'

import { IconProps } from '../../icon'

const Online: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M24.4917 35.7853C26.0771 35.7853 27.3624 34.5001 27.3624 32.9146C27.3624 31.3292 26.0771 30.044 24.4917 30.044C22.9063 30.044 21.6211 31.3292 21.6211 32.9146C21.6211 34.5001 22.9063 35.7853 24.4917 35.7853Z'
      fill='black'
    />
    <path
      d='M24.4918 23.9911C21.7688 23.9911 19.1607 24.9753 17.143 26.7797C16.6345 27.239 16.5853 28.01 17.0446 28.5185C17.5039 29.027 18.2749 29.0762 18.7834 28.6169C20.3581 27.2226 22.3922 26.4516 24.5082 26.4516C26.6243 26.4516 28.6584 27.2226 30.2331 28.6169C30.4628 28.8301 30.758 28.9286 31.0533 28.9286C31.3978 28.9286 31.7258 28.7973 31.9719 28.5185C32.4148 28.01 32.382 27.239 31.8735 26.7797C29.8558 24.9753 27.2313 23.9911 24.5247 23.9911H24.4918Z'
      fill='black'
    />
    <path
      d='M24.4917 18.0202C20.3252 18.0202 16.2899 19.4965 13.124 22.1703C12.5991 22.6132 12.5335 23.3842 12.9764 23.9091C13.2224 24.1879 13.5669 24.352 13.9114 24.352C14.1902 24.352 14.4691 24.2535 14.6988 24.0567C17.4218 21.7438 20.8993 20.4807 24.4753 20.4807C28.0513 20.4807 31.4961 21.7438 34.2355 24.0239C34.7604 24.4668 35.5314 24.4012 35.9743 23.8763C36.4172 23.3513 36.3516 22.5804 35.8266 22.1375C32.6607 19.4801 28.6254 18.0038 24.4917 18.0038V18.0202Z'
      fill='black'
    />
    <path
      d='M40.0425 17.6593C35.6955 14.0012 30.1675 12 24.4918 12C18.8161 12 13.2881 14.0176 8.94114 17.6593C8.41623 18.1022 8.35061 18.8731 8.79351 19.398C9.03957 19.6933 9.38404 19.8409 9.72852 19.8409C10.0074 19.8409 10.2862 19.7425 10.5159 19.5457C14.42 16.2649 19.3739 14.4605 24.4918 14.4605C29.6097 14.4605 34.5636 16.2649 38.4677 19.5457C38.9926 19.9886 39.7636 19.923 40.2065 19.398C40.6494 18.8731 40.5838 18.1022 40.0589 17.6593H40.0425Z'
      fill='black'
    />
  </svg>
)

export default Online
